var $6799bde136a492e8$exports = {};
$6799bde136a492e8$exports = {
    "decrease": (args)=>`Upadati ${args.fieldLabel}`,
    "increase": (args)=>`Pove\u{10D}ajte ${args.fieldLabel}`,
    "numberField": `\u{160}tevil\u{10D}no polje`
};


export {$6799bde136a492e8$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
